<ng-container *ngIf="{
  connextData: connextData$ | async,
  connextDataProperties: connextDataProperties$ | async,
  connectionProperties: connectionProperties$ | async,
  isLatestVersion: isLatestVersion$ | async,
} as resolver">

  <ng-container *ngIf="deviceId$ | async as deviceId; else skeletonView">

    <lib-block-title
      id="connext-title"
      [title]="labels.title">
    </lib-block-title>

    <section
      id="product-image"
      class="fx-col fx-gap-2 py-2 fx-align-center fx-justify-start radius-4 block-bg-contrast">
      <div
        *ngIf="resolver.connectionProperties?.length"
        class="fx-row radius-4 border-1 fx-align-center fx-gap-3 fx-justify-between p-3 w-full"
        [ngClass]="{
          'bg-green-100 border-green-400': statusConnection$ | async,
          'bg-red-100 border-red-400': !(statusConnection$ | async)
        }">
        <div
          *ngFor="let property of resolver.connectionProperties"
          class="w-full">
          <div
            *ngIf="property.name === labels.connection"
            class="w-full fx-row fx-align-center fx-gap-3">

            <div class="fx-row fx-align-center fx-gap-2">
              <mat-icon [ngClass]="property.iconCssClasses">
                {{ property.icon ?? 'info' }}
              </mat-icon>
              <div class="tw-text-sm tw-font-medium text-grey-300">
                {{ property.name | titlecase }}
              </div>
            </div>

            <div class="tw-text-base tw-font-normal text-grey-400 ml-auto">
              {{ property.value | titlecase }}
            </div>

          </div>
        </div>
      </div>

      <div class="fx-col fx-center fx-g-1">
        <img
          class="h-20"
          src="blocks-assets/images/productImages/monitoring/connext.svg">
        <span class="tw-font-medium tw-text-sm text-grey-400">
          {{ 'connext' | titlecase }}
        </span>
        <span class="ellipsed tw-font-normal tw-text-base text-grey-400">
          {{ deviceId }}
        </span>
      </div>
    </section>

    <ng-container *ngIf="isUpdatingFw$.value === false; else spinner">
      <ng-container *ngIf="connextDataProperties$ | async as properties">
        <section
          *ngIf="properties.length > 0"
          id="product-details">
          <div
            *ngFor="let property of properties"
            class="fx-row radius-4 block-bg-contrast fx-align-center fx-gap-3 fx-justify-between p-3">
            <mat-icon [ngClass]="property.iconCssClasses">
              {{ property.icon ?? 'info' }}
            </mat-icon>
            <div class="tw-text-sm tw-font-medium text-grey-300">
              {{ property.name | titlecase }}
            </div>
            <div
              class="tw-text-base tw-font-normal text-grey-400 ml-auto"
              [ngClass]="property.cssClasses">
              {{ property.value | titlecase }}
            </div>
          </div>
        </section>
      </ng-container>

      <section
        id="update-fw-button"
        class="fx-row fx-align-center fx-gap-3 w-full fx-justify-end fx-wrap p-3 block-bg-contrast fx-justify-between">
        <div
          *ngIf="!resolver.isLatestVersion"
          class="fx-row fx-align-center fx-gap-2">
          <mat-icon class="text-orange-400 min-s-6 s-6">
            info
          </mat-icon>
          <customer-title-content
            class="fx-g-1 body-1 w-full"
            [content]="labels.availableConnextUpgrade">
          </customer-title-content>
        </div>

        <customer-simple-button
          [ngClass]="{
            'w-full fx-col': resolver.isLatestVersion,
            'w-36': !resolver.isLatestVersion
          }"
          [label]="resolver.isLatestVersion ? labels.updated : labels.update"
          [disabled]="!(statusConnection$ | async) || (resolver.isLatestVersion !== null && resolver.isLatestVersion)"
          [type]="resolver.isLatestVersion ? 'secondary' : 'primary'"
          [action]="!resolver.isLatestVersion ? onUpdateFirmware.bind(this) : null">
        </customer-simple-button>

      </section>

    </ng-container>

    <lib-block-title
      id="connext-devices-title"
      [title]="labels.devicesTitle">
    </lib-block-title>

    <azzurro-table
      id="connext-device-table"
      mode="client"
      [data$]="devices$"
      [columns]="columns">
    </azzurro-table>

    <ng-template #spinner>
      <div
        id="product-details"
        class="fx-col fx-center block-bg-contrast s-full">
        <mat-spinner [diameter]="24"></mat-spinner>
      </div>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #skeletonView>
  <lib-block-title
    *ngIf="uiFramework === 'material'"
    id="connext-title"
    [title]="labels.title">
    <ion-skeleton-text
      animated="true"
      class="h-6 w-32">
    </ion-skeleton-text>
  </lib-block-title>
  <div
    id="product-image"
    class="fx-col fx-gap-2 py-2 fx-center radius-4 block-bg-contrast">
    <ion-skeleton-text
      animated="true"
      class="h-20 w-20">
    </ion-skeleton-text>
    <ion-skeleton-text
      animated="true"
      class="h-5 w-32">
    </ion-skeleton-text>
    <ion-skeleton-text
      animated="true"
      class="h-5 w-24">
    </ion-skeleton-text>
  </div>
  <section id="product-details">
    <div
      *ngFor="let i of [].constructor(6)"
      class="fx-row radius-4 block-bg-contrast fx-align-center fx-gap-3 fx-justify-between p-3">
      <ion-skeleton-text
        animated="true"
        class="h-6 w-6">
      </ion-skeleton-text>
      <ion-skeleton-text
        animated="true"
        class="h-5 w-24">
      </ion-skeleton-text>
      <ion-skeleton-text
        animated="true"
        class="h-5 w-24 ml-auto">
      </ion-skeleton-text>
    </div>
  </section>
</ng-template>
<ng-template
  #actionsTemplate
  let-row>
  <mat-icon
    class="pointer"
    (click)="onDeviceSelected.emit(row.device.id)">
    remove_red_eye
  </mat-icon>
</ng-template>